import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getMediaDone = async (status) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/request_media/data/${status}`, {
        headers: { Authorization: token }
    });
};

export const doneMedia = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/request_media/done/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const nonDoneMedia = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/request_media/undone/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const rejectMedia = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/request_media/reject/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const hideRequestMedia = async (id, formDate) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/request_media/hide/${id}`, formDate, {
        headers: { Authorization: token }
    });
};